<template>
  <div class="specialty-information mt-1">
    <div class="row header">
      <div class="col-12 mb-0 mt-2 pt-2 pb-2 ml-3">
        <em
          class="fas rounded-circle p-1 mr-2 color-green shadow bg-white"
          :class="editModel.isNew ? 'fa-plus' : 'fa-edit'"
        />
        <span>{{ editModel.isNew ? 'Añadir' : 'Editar' }} Especialidad</span>
      </div>
    </div>
    <div class="row body">
      <div class="col">
        <div class="col-xs-12">
          <validation-observer ref="formValidator">
            <specialty-information
              v-model="editModel"
              :used-specialties="usedSpecialties"
            />
            <error
              v-if="customErrorMessage != null"
              :message="customErrorMessage"
              variant="no-border"
            />
          </validation-observer>
        </div>
        <div class="col-xs-12 pb-2">
          <div class="row">
            <div
              class="col-sm-12 text-right mr-0 mr-md-3 mr-sm-0 actions d-flex d-md-block d-sm-flex justify-content-center align-items-center px-5 mt-3 mt-md-0 mt-sm-3"
            >
              <action-button
                class="mr-2 py-2 btnCancel"
                i="fas fa-times-circle"
                text="Cancelar"
                variant="outline-danger"
                @click="cancel"
              />

              <action-button
                class="py-2"
                i="fas fa-plus"
                text="Añadir"
                variant="success"
                @click="save"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import SpecialtyInformation from './SpecialtyInformation';
import Error from '@/components/common/Error';

import alert from '@/mixins/alert.mixin';

export default {
  name: 'SpecialtyInformationAddEdit',
  components: {
    SpecialtyInformation,
    Error,
    ActionButton,
  },
  mixins: [alert],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    usedSpecialties: {
      type: Array,
      default: () => [],
    },
    customErrorMessage: {
      type: String,
      default: () => null,
    },
  },
  data() {
    return {
      editModel: Object.assign({}, this.value), //Copy the model to eliminate the reference
    };
  },
  watch: {
    value: function(newValue) {
      this.editModel = Object.assign({}, newValue); //Copy the model to eliminate the reference
    },
  },
  mounted() {},
  methods: {
    async save() {
      const isValid = await this.$refs.formValidator.validate();

      if (isValid) {
        if (this.editModel.startDate >= this.editModel.endDate) {
          this.ShowToast(
            'Error',
            'La fecha desde no puede ser mayor o igual a la fecha hasta.',
            'error'
          );
          return;
        }

        this.$emit('on-saved', this.editModel);
      } else {
        //TODO: Use the stored one
        this.ShowToast('Error', 'Información incompleta. (190803)', 'error');
      }
    },
    async cancel() {
      this.$emit('on-cancel');
    },
  },
};
</script>
<style scoped>
.actions {
  padding-right: 35px;
  margin-bottom: 10px;
}

@media (min-width: 576px) {
  .specialty-information .header {
    padding-left: 0.25 !important;
    padding-right: 0.25 !important;
  }

  .specialty-information .btnCancel {
    float: left;
  }
  .actions {
    padding-left: 35px;
  }
}

@media (min-width: 768px) {
  .specialty-information .header {
    padding-left: 0.33rem !important;
    padding-right: 0.33rem !important;
  }

  .specialty-information .btnCancel {
    float: inherit;
  }
}

@media (min-width: 992px) {
  .address-information .header {
    padding-left: 0.66rem !important;
    padding-right: 0.66rem !important;
  }
}

@media (min-width: 1200px) {
  .address-information .header {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
}
</style>
